import React from "react";

import Detail from "../Detail/Detail";
import env from "../../../utils/env";

const ShippingAddress = props => {
  const { title, userData } = props;
  const { shippingAddress } = userData;

  const {
    firstName,
    lastName,
    address1,
    address2,
    city,
    state,
    postcode,
    country
  } = shippingAddress;

  return (
    <Detail icon={"fa-home"} title={title}>
      <p className="desc mar-0">
        {firstName} {lastName}
      </p>
      <p className="desc mar-0">{address1}</p>
      <p className="desc mar-0">{address2}</p>
      <p className="desc mar-0">{`${city}, ${!!state ? state : country}`}</p>
      <p className="desc mar-0">{postcode}</p>
      <p className="desc mar-0"><a href={`${env.envURL}/my-account/`}>Edit Address</a></p> 
    </Detail>
  );
};

export default ShippingAddress;



// WEBPACK FOOTER //
// ./src/Components/Header/ShippingAddress/ShippingAddress.js